import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import SubscriptionCenter from './SubscriptionCenter';
import {
  SubscriptionsChartPointType,
  SubscriptionsStatType,
} from '../../../../types/subscriptionsSection';

import s from './SubscriptionCenterBox.scss';

interface Props extends WidgetBoxProps {
  stats?: SubscriptionsStatType[];
  chartData?: SubscriptionsChartPointType[];
}

const SubscriptionCenterBox: React.FC<Props> = ({
  moduleId,
  widgetMoveUp,
  widgetMoveDown,
  widgetRemove,
  isOwner,
  profileOwnerUser,
  section,
  zone,
  stats,
  chartData,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <WidgetBox
      className={s['root']}
      section={section}
      zone={zone}
      header={t(`widgets.subscription_center.header`)}
      hasMore={false}
      moduleId={moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={false}
    >
      <SubscriptionCenter
        moduleId={moduleId}
        className={c(s['subscription-center'], className)}
        stats={stats}
        chartData={chartData}
      />
    </WidgetBox>
  );
};

SubscriptionCenterBox.displayName = 'SubscriptionCenterBox';
export default SubscriptionCenterBox;
